import React, { useEffect } from 'react';
import './assets/scss/style.scss';
import { ToastContainer } from 'react-toastify';
import DefaultSwitch from './components/router/DefaultSwitch';
import NewCarModal from './components/Cars/NewCarModal';
import 'react-toastify/dist/ReactToastify.css';
import NewParkingLotModal from './components/Administration/NewParkingLotModal';
import EditParkingLotModal from './components/Administration/EditParkingLotModal';
import NewParkingSpotModal from './components/Administration/NewParkingSpotModal';
import EditParkingSpotModal from './components/Administration/EditParkingSpotModal';
import UserPermanentParkingLotModal from './components/Administration/UserPermanentParkingLotModal';
import SharePermanentSpotModal from './components/Administration/SharePermanentSpotModal';
import config from './config';

function App() {
  return (
    <>
      <ToastContainer />
      <EditParkingSpotModal />
      <NewParkingSpotModal />
      <EditParkingLotModal />
      <NewParkingLotModal />
      <UserPermanentParkingLotModal />
      <SharePermanentSpotModal />
      <div className="container">
        <NewCarModal />
        <div className="page-container">
          <div className="page">
            <DefaultSwitch />
          </div>
        </div>
        <div className="car-background" />
      </div>
    </>
  );
}

export default App;
